export default "__VITE_ASSET__CfpKxJ1W__"